import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "occupancy" }
const _hoisted_4 = {
  key: 0,
  class: "chartWrapper"
}
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_car" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "flex"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_el-polnilnica" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "flex"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_invalid" }, null, -1)
const _hoisted_12 = {
  key: 3,
  class: "flex"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_friends" }, null, -1)
const _hoisted_14 = { class: "timeAndPricing flex" }
const _hoisted_15 = { class: "day" }
const _hoisted_16 = { class: "timeAndPricing flex" }
const _hoisted_17 = { class: "day" }
const _hoisted_18 = {
  key: 0,
  class: "parkingMap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicDonutChart = _resolveComponent("BasicDonutChart")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_MapCustom = _resolveComponent("MapCustom")!
  const _component_SidebarWrapper = _resolveComponent("SidebarWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarWrapper, {
    title: _ctx.$t('parking.title'),
    sidebarComponent: _ctx.sidebarComponent,
    mapComponent: _ctx.mapComponent,
    sidebarLeft: true
  }, {
    default: _withCtx(() => [
      (_ctx.parking !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.parking.name) + ", " + _toDisplayString(_ctx.parking.address), 1),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.parking.smart)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("parking.occupancy")), 1),
                    _createVNode(_component_BasicDonutChart, {
                      percentage: _ctx.occupancy,
                      stops: [
              [0.25, '#55BF3B'],
              [0.5, '#DDDF0D'],
              [0.66, '#DF5353'],
            ],
                      min: 0,
                      max: 100,
                      unit: "%"
                    }, null, 8, ["percentage", "stops"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("ul", null, [
                (_ctx.parking.spaces_regular > 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("span", {
                        class: _normalizeClass(
                _ctx.getValueColorClass(
                  _ctx.parking.spaces_regular_occupied,
                  _ctx.parking.spaces_regular
                )
              )
                      }, _toDisplayString(_ctx.parking.spaces_regular - _ctx.parking.spaces_regular_occupied), 3),
                      _createTextVNode(" / " + _toDisplayString(_ctx.parking.spaces_regular), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.parking.spaces_ev > 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", {
                        class: _normalizeClass(
                _ctx.getValueColorClass(
                  _ctx.parking.spaces_ev_occupied,
                  _ctx.parking.spaces_ev
                )
              )
                      }, _toDisplayString(_ctx.parking.spaces_ev - _ctx.parking.spaces_ev_occupied), 3),
                      _createTextVNode("/ " + _toDisplayString(_ctx.parking.spaces_ev), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.parking.spaces_accessible > 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", {
                        class: _normalizeClass(
                _ctx.getValueColorClass(
                  _ctx.parking.spaces_accessible_occupied,
                  _ctx.parking.spaces_accessible
                )
              )
                      }, _toDisplayString(_ctx.parking.spaces_accessible - _ctx.parking.spaces_accessible_occupied), 3),
                      _createTextVNode("/ " + _toDisplayString(_ctx.parking.spaces_accessible), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.parking.spaces_parent > 0)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", {
                        class: _normalizeClass(
                _ctx.getValueColorClass(
                  _ctx.parking.spaces_parent_occupied,
                  _ctx.parking.spaces_parent
                )
              )
                      }, _toDisplayString(_ctx.parking.spaces_parent - _ctx.parking.spaces_parent_occupied), 3),
                      _createTextVNode("/ " + _toDisplayString(_ctx.parking.spaces_parent), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_Accordion, {
              activeIndex: 0,
              class: "particleContentInfo"
            }, {
              default: _withCtx(() => [
                (
            _ctx.parking.working_hours !== null && _ctx.parking.working_hours.length > 0
          )
                  ? (_openBlock(), _createBlock(_component_AccordionTab, {
                      key: 0,
                      header: "Obratovalni čas"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parking.working_hours, (hours) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: hours.id
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getRRuleText(hours.recurrence)), 1),
                                _createElementVNode("span", null, _toDisplayString(hours.open_time) + " - " + _toDisplayString(hours.close_time), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.parking.prices !== null && _ctx.parking.prices.length > 0)
                  ? (_openBlock(), _createBlock(_component_AccordionTab, {
                      key: 1,
                      header: "Cenik"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parking.prices, (price) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: price.id
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getRRuleText(price.recurrence)), 1),
                                _createElementVNode("span", null, _toDisplayString(price.start_time) + " - " + _toDisplayString(price.end_time), 1),
                                _createElementVNode("span", null, _toDisplayString(price.price + " " + price.currency) + "/h", 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.marker !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_MapCustom, {
                    center: _ctx.marker.position,
                    markers: [_ctx.marker]
                  }, null, 8, ["center", "markers"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "sidebarComponent", "mapComponent"]))
}